<script>
import appConfig from "@/app.config";
import Order from "@/router/views/orders/orderComponent"
import Layout from "../../layouts/main";

/**
 * Orders-list component
 */
export default {
  page: {
    title: "Bon de  Commande",
    meta: [{ name: "description", content: appConfig.description }]
  },

  components: { Layout,Order },

  props:{
    orderId:{
      type:Number,
      default:0
    },

    showTransfer:{
      type: Boolean,
      default:null
    },

    showCashTotal:{
      type: Boolean,
      default:false
    },

  }


}

</script>


<template>
  <Layout>
     <Order :orderId=this.orderId :showTransfer=this.showTransfer :showCashTotal=this.showCashTotal />
  </Layout>
</template>